import axios from 'axios'
import { reportError } from './errorReporter'

const api_host = 'https://tiktokvoice.net'

/**
 * Action 类型枚举
 */
export const ActionType = {
  // Home actions
  HOME_PREVIEW_AUDIO: 'home-preview-audio',
  HOME_PLAY_AUDIO: 'home-play-audio',
  HOME_GEN_AUDIO: 'home-gen-audio',
  HOME_GENPOPUP_LOGIN: 'home-genpopup-login',
  HOME_GENPOPUP_SUBSCRIPT: 'home-genpopup-subscript',
  HOME_GEN_FAILED: 'home-gen-failed',
  HOME_DOWNPOPUP_LOGIN: 'home-downpopup-login',
  HOME_DOWNPOPUP_SUBSCRIPT: 'home-downpopup-subscript',
  HOME_DOWNLOAD_SUCCESS: 'home-download-success',
  HOME_LOGIN_SUCCESS: 'home-login-success',
  HOME_LOGIN_FAILED: 'home-login-failed',

  // Sound effects actions
  SOUNDS_GEN_AUDIO: 'sounds-gen-audio',
  SOUNDS_GENPOPUP_LOGIN: 'sounds-genpopup-login',
  SOUNDS_GENPOPUP_SUBSCRIPT: 'sounds-genpopup-subscript',
  SOUNDS_GEN_FAILED: 'sounds-gen-failed',
  SOUNDS_DOWNPOPUP_LOGIN: 'sounds-downpopup-login',
  SOUNDS_DOWNLOAD_SUCCESS: 'sounds-download-success',
  SOUNDS_DOWNPOPUP_SUBSCRIPT: 'sounds-downpopup-subscript',
  SOUNDS_LOGIN_SUCCESS: 'sounds-login-success',
  SOUNDS_LOGIN_FAILED: 'sounds-login-failed',

}

// 使用 Object.freeze 防止对象被修改
Object.freeze(ActionType)

/**
 * 记录用户行为数据
 * @param {Object} params - 行为数据参数
 * @param {string} params.email - 用户邮箱
 * @param {ActionType} params.action - 行为类型
 * @param {string} params.domain - 域名
 * @param {string} params.modelcat - 模型类别
 * @param {string} params.modelname - 模型名称
 * @param {string} params.tkuid - 用户唯一标识
 * @returns {Promise} 请求结果
 */
export const trackAction = async ({
  email,
  action,
  domain = 'tiktokvoice.net',
  modelcat = '',
  modelname = '',
  tkuid = ''
}) => {
  try {
    const uri = `${api_host}/lapi/actionadd`
    const formData = new FormData()
    formData.append('email', email)
    formData.append('action', action)
    formData.append('domain', domain)
    formData.append('modelcat', modelcat)
    formData.append('modelname', modelname)
    formData.append('uid', tkuid)
    const response = await axios.post(uri, formData, {
      headers: { 
        'Content-Type': 'multipart/form-data',
        // 添加缓存控制头，避免 iOS 缓存问题
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    })
    return response
  } catch (error) {
    reportError(error, `trackAction error - email: ${email}, action: ${action}, domain: ${domain}, modelcat: ${modelcat}, modelname: ${modelname}, tkuid: ${tkuid}`);
    // 重要：将错误向上抛出，而不是静默处理
    // throw error;
  }
}